<template>
    <section>
        <AppBackground :title="title"/>
        <v-container>
            <v-row>
                <v-col>
                    <div>送信されたコメントは本HPの管理者が確認した後、「みんなのコメント」に表示されます。</div>
                    <div>個人情報や誹謗中傷が含まれる内容、その他モラルに反するコメントはお控えください。</div>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-form v-model="valid" ref="form" class="form">
                        <br>
                        <v-text-field
                            label='名前'
                            v-model="user"
                            :rules="formRules"
                        ></v-text-field>
                        <br>
                        <v-textarea
                            label='コメント'
                            v-model="message"
                            solo
                            :rules="formRules"
                        ></v-textarea>
                        <v-btn
                            v-on:click="doAdd"
                            color="accent"
                            class="btn"
                            :disabled="!valid"
                        >送信</v-btn>
                    </v-form>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>
import firebase from "firebase/app";
import "firebase/database";
import AppBackground from './AppBackgroundHolder.vue'

export default {
    name: 'SubmitMessage',
    data () {
        return {
            title:'コメントフォーム',
            valid: false,
            user: '',
            message: '',
            lists: [],
            formRules: [v => !!v || 'この項目は必須です'],
        }
    },
    components: {
        AppBackground,
    },
    created(){
        var vue = this
        firebase.database().ref('bord').on('value',
            (snapshot) => {
                vue.lists = snapshot.val()
            }
        )
    },
    methods: {
        resetValidation() {
            this.$refs.form.resetValidation()
        },
        doAdd() {
            var now = new Date()
            firebase.database().ref("bord").push({
                user: this.user,
                message: this.message,
                date: now.getMonth()+ 1 + '月' + now.getDate() + '日' + now.getHours() + '時' + now.getMinutes() + '分'
            })
            this.dialog = false
            this.resetValidation()
            this.user = ''
            this.message = ''
        }
    }
}
</script>

<style lang="scss" scoped>
.comment-form {
    padding: 30px;
}
.form {
    margin: 20px;
}
.btn {
    margin-bottom: 100px;
    width: 150px;
    font-size: 20px;
}

</style>
